angular.module('graph').controller('ph-endorse', [
    '$scope', 'ph-core', 'ph-touch-service', '$rootScope', '$timeout',
    function ($scope, $core, $phtouch, $root, $timeout) {

        $scope.$data = {
            endorses: [],
            pagination: {
                page: 0,
                let: 0
            }
        };

        $scope.entry_id = 0;

        $scope.entry    = null;

        $scope.$entry = function (name, id) {
            if (name) $scope.entry = name;
            if (id)   $scope.entry_id = id;

            $scope.$on('ph-root-endorse-update', function($e, $id, $space) {
                if ($id) $scope.entry_id = $id;
                if ($space) $scope.entry = $space;

                $scope.init();
            });
        };

        function make(state)
        {
            if (state === 'entry') {
                var $entry = $scope.entry !== null ? $scope.entry + '/' : '';
                $entry += $scope.entry_id !== 0 ? $scope.entry_id + '/' : '';

                return $entry;
            }
        }

        $scope.init = function ($space, $id) {
            if ($space) $scope.entry = $space;
            if ($id) $scope.entry_id = $id;

            $scope.$request.get.tags();
            $scope.$request.get.endorses();
        };

        $scope.$multiSelect = {
            model: [],
            data: [],
            settings: {
                enableSearch: true,
                buttonClasses: 'blue',
                showCheckAll: false,
                showUncheckAll: false
            },
            text: {buttonDefaultText: 'Update'},
            events: {
                onItemSelect: function ($tag) {
                    $scope.$request.upload.tag($tag)
                },
                onItemDeselect: function ($tag) {
                    $scope.$request.delete.tag($tag);
                }
            }
        };

        $scope.$request = {
            "get": {
                "tags": function () {
                    $core.get('/xhr/' + make('entry') + 'endorse/tags')
                        .then(function ($response) {
                            if ($response.data.state === 0) {
                                $scope.$multiSelect.data = $response.data.data;
                            }
                        });
                },
                "endorses": function () {
                    var $query = $core.$uri.$query.new({
                        page: +(++$scope.$data.pagination.page),
                        let: $scope.$data.pagination.let
                    }).str();

                    $core.get('/xhr/' + make('entry') + 'endorses?' + $query)
                        .then(function ($response) {
                            if ($response.data.state === 0) {
                                /**
                                 *
                                 */
                                $scope.$data.endorses = $scope.$data.endorses.concat(
                                    $response.data.data
                                );

                                if ($response.data.data.length > 0)
                                    $response.data.data.forEach(function ($endorse) {
                                        $scope.$multiSelect.model.push({id: $endorse.tag.id});
                                    });
                            }
                        });
                },
                "endorse": function ($tag) {
                    var $query = $core.$uri.$query.new({
                        page: +(++$scope.$data.pagination.page),
                        let: $scope.$data.pagination.let
                    }).str();

                    $core.get('/xhr/' + make('entry') + 'endorse/' + $tag.id + '?' + $query)
                        .then(function ($response) {
                            if ($response.data.state === 0) {
                                /**
                                 *
                                 */
                                $scope.$data.endorses = $scope.$data.endorses.concat(
                                    $response.data.data
                                );
                            }
                        });
                }
            },
            "delete": {
                "endorse": function ($endorse) {
                    $core.delete('/xhr/' + make('entry') + 'endorse/' + $endorse.tag.id)
                        .then(function ($response) {
                            if ($response.data.state === 0) {
                                $endorse.im_endorsed = false;
                                $endorse.endorses--;
                            }
                        });
                },
                "tag": function ($tag) {
                    $core.delete('/xhr/' + make('entry') + 'endorse/tag/' + $tag.id)
                        .then(function ($response) {
                            if ($response.data.state === 0) {
                                for (var i = 0; i < $scope.$data.endorses.length; i++)
                                    if ($scope.$data.endorses[i].tag.id === $tag.id)
                                        $scope.$data.endorses.splice(i, 1);

                                for (i = 0; i < $scope.$multiSelect.model.length; i++)
                                    if ($scope.$multiSelect.model[i].id === $tag.id)
                                        $scope.$multiSelect.model.splice(i, 1);
                            }
                        });
                }
            },
            "upload": {
                "endorse": function ($endorse) {
                    $timeout(function () {
                        $core.post('/xhr/' + make('entry') + 'endorse/' + $endorse.tag.id)
                            .then(function ($response) {
                                if ($response.data.state === 0) {
                                    $endorse.im_endorsed = true;
                                    $endorse.endorses++;
                                }
                            });
                    }, 10);
                },
                "tag": function ($tag) {
                    $timeout(function () {
                        $core.post('/xhr/' + make('entry') + 'endorse/tag/' + $tag.id)
                            .then(function ($response) {
                                if ($response.data.state === 0) {
                                    $scope.$data.endorses = $scope.$data.endorses.concat(
                                        $response.data.data
                                    )
                                }
                            });
                    }, 10);
                }
            }
        };
    }
]);

angular.module('graph').controller('ph-read-endorse-tab', [
    '$scope', '$controller', '$rootScope', 'ph-touch-service', 'ph-broadcast',
    function ($scope, $controller, $root, $phtouch, $broadcast) {
        angular.extend(this, $controller('ph-endorse', {$scope: $scope}));

        var $module = 'ph-read-endorse-tab';

        $phtouch.$watch($scope, $module, function () {
            $phtouch.$touch($module, function () {
                $scope.init();
            });
        });
    }
]);